// Per-achievement artwork from the Figma page "Achievements icon set" (7262:134819): the
// "Achievements overview" frame (7262:134820) for unlocked art and "Achievements overview Locked"
// (7262:134990) for the greyscale locked art, exported at 400px from the Dev Mode asset server.
//
// Keyed by the backend tier's iconKey and named after it. Figma's series don't line up with the
// backend catalog everywhere: a few badges have a number baked in, so a badge is only mapped where
// that number matches the tier's target. level-elite (80), active-days-dedicated (100),
// purchases-regular-customer (25) and purchases-loyal-customer (40) have no matching art and keep
// the generic tier badge.
import ActiveDaysLongTermPlayerPng from './active-days-long-term-player.png';
import ActiveDaysLongTermPlayerLockedPng from './active-days-long-term-player-locked.png';
import ActiveDaysRegularPng from './active-days-regular.png';
import ActiveDaysRegularLockedPng from './active-days-regular-locked.png';
import ActiveDaysWelcomeBackPng from './active-days-welcome-back.png';
import ActiveDaysWelcomeBackLockedPng from './active-days-welcome-back-locked.png';
import ArcadeRoundsFanPng from './arcade-rounds-fan.png';
import ArcadeRoundsFanLockedPng from './arcade-rounds-fan-locked.png';
import ArcadeRoundsMasterPng from './arcade-rounds-master.png';
import ArcadeRoundsMasterLockedPng from './arcade-rounds-master-locked.png';
import ArcadeRoundsRegularPng from './arcade-rounds-regular.png';
import ArcadeRoundsRegularLockedPng from './arcade-rounds-regular-locked.png';
import BigPotsBigWinnerPng from './big-pots-big-winner.png';
import BigPotsBigWinnerLockedPng from './big-pots-big-winner-locked.png';
import BigPotsHighRollerPng from './big-pots-high-roller.png';
import BigPotsHighRollerLockedPng from './big-pots-high-roller-locked.png';
import BigPotsJackpotHandPng from './big-pots-jackpot-hand.png';
import BigPotsJackpotHandLockedPng from './big-pots-jackpot-hand-locked.png';
import DuelsWonChampionPng from './duels-won-champion.png';
import DuelsWonChampionLockedPng from './duels-won-champion-locked.png';
import DuelsWonMasterPng from './duels-won-master.png';
import DuelsWonMasterLockedPng from './duels-won-master-locked.png';
import FriendsPopularPng from './friends-popular.png';
import FriendsPopularLockedPng from './friends-popular-locked.png';
import FriendsSocialPlayerPng from './friends-social-player.png';
import FriendsSocialPlayerLockedPng from './friends-social-player-locked.png';
import FriendsWellConnectedPng from './friends-well-connected.png';
import FriendsWellConnectedLockedPng from './friends-well-connected-locked.png';
import GiftsReceivedFanFavoritePng from './gifts-received-fan-favorite.png';
import GiftsReceivedFanFavoriteLockedPng from './gifts-received-fan-favorite-locked.png';
import GiftsReceivedGiftCollectorPng from './gifts-received-gift-collector.png';
import GiftsReceivedGiftCollectorLockedPng from './gifts-received-gift-collector-locked.png';
import GiftsSentGenerousPlayerPng from './gifts-sent-generous-player.png';
import GiftsSentGenerousPlayerLockedPng from './gifts-sent-generous-player-locked.png';
import GiftsSentGiftGiverPng from './gifts-sent-gift-giver.png';
import GiftsSentGiftGiverLockedPng from './gifts-sent-gift-giver-locked.png';
import HandsPlayedDedicatedPlayerPng from './hands-played-dedicated-player.png';
import HandsPlayedDedicatedPlayerLockedPng from './hands-played-dedicated-player-locked.png';
import HandsPlayedGettingStartedPng from './hands-played-getting-started.png';
import HandsPlayedGettingStartedLockedPng from './hands-played-getting-started-locked.png';
import HandsPlayedRegularPlayerPng from './hands-played-regular-player.png';
import HandsPlayedRegularPlayerLockedPng from './hands-played-regular-player-locked.png';
import HandsPlayedSvaraLegendPng from './hands-played-svara-legend.png';
import HandsPlayedSvaraLegendLockedPng from './hands-played-svara-legend-locked.png';
import HandsPlayedSvaraVeteranPng from './hands-played-svara-veteran.png';
import HandsPlayedSvaraVeteranLockedPng from './hands-played-svara-veteran-locked.png';
import HandsWonChampionPng from './hands-won-champion.png';
import HandsWonChampionLockedPng from './hands-won-champion-locked.png';
import HandsWonWinnerPng from './hands-won-winner.png';
import HandsWonWinnerLockedPng from './hands-won-winner-locked.png';
import HandsWonWinningWaysPng from './hands-won-winning-ways.png';
import HandsWonWinningWaysLockedPng from './hands-won-winning-ways-locked.png';
import LevelExperiencedPng from './level-experienced.png';
import LevelExperiencedLockedPng from './level-experienced-locked.png';
import LevelLegendaryPng from './level-legendary.png';
import LevelLegendaryLockedPng from './level-legendary-locked.png';
import LevelVeteranPng from './level-veteran.png';
import LevelVeteranLockedPng from './level-veteran-locked.png';
import PurchasesShopperPng from './purchases-shopper.png';
import PurchasesShopperLockedPng from './purchases-shopper-locked.png';
import SvarkaImmortalPng from './svarka-immortal.png';
import SvarkaImmortalLockedPng from './svarka-immortal-locked.png';
import SvarkaLegendPng from './svarka-legend.png';
import SvarkaLegendLockedPng from './svarka-legend-locked.png';
import SvarkaMasterPng from './svarka-master.png';
import SvarkaMasterLockedPng from './svarka-master-locked.png';
import ThreeSevensLegendPng from './three-sevens-legend.png';
import ThreeSevensLegendLockedPng from './three-sevens-legend-locked.png';
import ThreeSevensMasterPng from './three-sevens-master.png';
import ThreeSevensMasterLockedPng from './three-sevens-master-locked.png';
import ThreeSevensSeekerPng from './three-sevens-seeker.png';
import ThreeSevensSeekerLockedPng from './three-sevens-seeker-locked.png';

type BadgePair = { unlocked: typeof HandsWonWinnerPng; locked: typeof HandsWonWinnerPng };

export const IconKeyBadgeArtwork: Record<string, BadgePair> = {
	'hands-played-getting-started': {
		unlocked: HandsPlayedGettingStartedPng,
		locked: HandsPlayedGettingStartedLockedPng,
	},
	'hands-played-regular-player': {
		unlocked: HandsPlayedRegularPlayerPng,
		locked: HandsPlayedRegularPlayerLockedPng,
	},
	'hands-played-dedicated-player': {
		unlocked: HandsPlayedDedicatedPlayerPng,
		locked: HandsPlayedDedicatedPlayerLockedPng,
	},
	'hands-played-svara-veteran': {
		unlocked: HandsPlayedSvaraVeteranPng,
		locked: HandsPlayedSvaraVeteranLockedPng,
	},
	'hands-played-svara-legend': {
		unlocked: HandsPlayedSvaraLegendPng,
		locked: HandsPlayedSvaraLegendLockedPng,
	},
	'hands-won-winner': { unlocked: HandsWonWinnerPng, locked: HandsWonWinnerLockedPng },
	'hands-won-winning-ways': {
		unlocked: HandsWonWinningWaysPng,
		locked: HandsWonWinningWaysLockedPng,
	},
	'hands-won-champion': { unlocked: HandsWonChampionPng, locked: HandsWonChampionLockedPng },
	'big-pots-big-winner': { unlocked: BigPotsBigWinnerPng, locked: BigPotsBigWinnerLockedPng },
	'big-pots-high-roller': { unlocked: BigPotsHighRollerPng, locked: BigPotsHighRollerLockedPng },
	'big-pots-jackpot-hand': { unlocked: BigPotsJackpotHandPng, locked: BigPotsJackpotHandLockedPng },
	'three-sevens-seeker': { unlocked: ThreeSevensSeekerPng, locked: ThreeSevensSeekerLockedPng },
	'three-sevens-master': { unlocked: ThreeSevensMasterPng, locked: ThreeSevensMasterLockedPng },
	'three-sevens-legend': { unlocked: ThreeSevensLegendPng, locked: ThreeSevensLegendLockedPng },
	'svarka-master': { unlocked: SvarkaMasterPng, locked: SvarkaMasterLockedPng },
	'svarka-legend': { unlocked: SvarkaLegendPng, locked: SvarkaLegendLockedPng },
	'svarka-immortal': { unlocked: SvarkaImmortalPng, locked: SvarkaImmortalLockedPng },
	'duels-won-champion': { unlocked: DuelsWonChampionPng, locked: DuelsWonChampionLockedPng },
	'duels-won-master': { unlocked: DuelsWonMasterPng, locked: DuelsWonMasterLockedPng },
	'arcade-rounds-regular': {
		unlocked: ArcadeRoundsRegularPng,
		locked: ArcadeRoundsRegularLockedPng,
	},
	'arcade-rounds-fan': { unlocked: ArcadeRoundsFanPng, locked: ArcadeRoundsFanLockedPng },
	'arcade-rounds-master': { unlocked: ArcadeRoundsMasterPng, locked: ArcadeRoundsMasterLockedPng },
	'friends-social-player': {
		unlocked: FriendsSocialPlayerPng,
		locked: FriendsSocialPlayerLockedPng,
	},
	'friends-popular': { unlocked: FriendsPopularPng, locked: FriendsPopularLockedPng },
	'friends-well-connected': {
		unlocked: FriendsWellConnectedPng,
		locked: FriendsWellConnectedLockedPng,
	},
	'gifts-sent-gift-giver': { unlocked: GiftsSentGiftGiverPng, locked: GiftsSentGiftGiverLockedPng },
	'gifts-sent-generous-player': {
		unlocked: GiftsSentGenerousPlayerPng,
		locked: GiftsSentGenerousPlayerLockedPng,
	},
	'gifts-received-gift-collector': {
		unlocked: GiftsReceivedGiftCollectorPng,
		locked: GiftsReceivedGiftCollectorLockedPng,
	},
	'gifts-received-fan-favorite': {
		unlocked: GiftsReceivedFanFavoritePng,
		locked: GiftsReceivedFanFavoriteLockedPng,
	},
	'level-experienced': { unlocked: LevelExperiencedPng, locked: LevelExperiencedLockedPng },
	'level-veteran': { unlocked: LevelVeteranPng, locked: LevelVeteranLockedPng },
	'level-legendary': { unlocked: LevelLegendaryPng, locked: LevelLegendaryLockedPng },
	'active-days-welcome-back': {
		unlocked: ActiveDaysWelcomeBackPng,
		locked: ActiveDaysWelcomeBackLockedPng,
	},
	'active-days-regular': { unlocked: ActiveDaysRegularPng, locked: ActiveDaysRegularLockedPng },
	'active-days-long-term-player': {
		unlocked: ActiveDaysLongTermPlayerPng,
		locked: ActiveDaysLongTermPlayerLockedPng,
	},
	'purchases-shopper': { unlocked: PurchasesShopperPng, locked: PurchasesShopperLockedPng },
};
